import { Sprite, Texture, Text } from 'pixi.js';
import { Tween, Easing } from '@tweenjs/tween.js';
import Button from './Button.js';

const pressHeight = 6;
let downObject = '';

class PressButton extends Button {
	constructor(obj) {
		super(obj);
		if (obj.bg) {
			this.bg = Sprite.from(Texture.from(obj.bg));
			this.addChild(this.bg);
			this.bg.x = -this.bg.width / 2;
			this.bg.y = -this.bg.height / 2 + 10;
		}
		if (obj.fg) {
			this.fg = Sprite.from(Texture.from(obj.fg));
			this.addChild(this.fg);
			this.fg.x = -this.fg.width / 2;
			this.fg.y = -this.fg.height / 2;
			if (obj.scale) {
				this.fg.scale.set(obj.scale.x, obj.scale.y);
			}
		}
		if (obj.bg2) {
			this.bg2 = Sprite.from(Texture.from(obj.bg2));
			this.addChild(this.bg2);
			this.bg2.x = -this.bg2.width / 2;
			this.bg2.y = -this.bg2.height / 2;
			this.bg2.alpha = 0;
		}
		if (obj.fg2) {
			this.fg2 = Sprite.from(Texture.from(obj.fg2));
			this.addChild(this.fg2);
			this.fg2.x = -this.fg2.width / 2;
			this.fg2.y = -this.fg2.height / 2;
			this.fg2.alpha = 0;
		}
		if (obj.icon) {
			this.icon = Sprite.from(Texture.from(obj.icon));
			this.icon.anchor.set(0.5, 0.5);
			if (obj.fg) {
				this.icon.position.set(this.fg.width / 2, this.fg.height / 2 + 2);
				this.fg.addChild(this.icon);
			} else {
				this.bg.addChild(this.icon);
				this.icon.position.set(this.bg.width / 2, this.bg.height / 2 + 2);
			}
		}
		if (obj.iconActive) {
			this.iconActive = Sprite.from(Texture.from(obj.iconActive));
			this.iconActive.anchor.set(0.5, 0.5);
			if (obj.fg2) {
				this.iconActive.position.set(this.fg2.width / 2, this.fg2.height / 2);
				this.fg2.addChild(this.iconActive);
			}
		}
		if (obj.text) {
			this.text = new Text(
				window.lm[obj.text].value,
				window.lm[obj.text].config
			);
			// this.textBg = new Text(window.lm[obj.text].value, window.lm[obj.text].config);
			this.text.anchor.set(0.5, 0.5);
			// this.textBg.anchor.set(0.5, 0.5);
			if (obj.fg) {
				this.text.position.set(this.fg.width / 2, this.fg.height / 2 + 10);
				this.fg.addChild(this.text);
			}
			// this.textBg.position.set(this.bg.width / 2, this.bg.height / 20);
			// this.bg.addChild(this.textBg);
		}
		if (window.isMobile || window.isTablet) {
			this.on('touchstart', this.mouseDownHandler.bind(this));
			this.on('touchend', this.mouseUpHandler.bind(this));
			this.on('touchcancel', this.mouseUpHandler.bind(this));
			obj.type !== 'ToggleButton' &&
				this.on('touchendoutside', this.mouseUpHandler.bind(this));
		} else {
			this.on('keydown', this.mouseDownHandler.bind(this));
			this.on('mousedown', this.mouseDownHandler.bind(this));
			//this.on("mouseover", this.mouseOverHandler.bind(this));

			this.on('mouseup', this.mouseUpHandler.bind(this));
			obj.type !== 'ToggleButton' &&
				this.on('mouseupoutside', this.mouseUpHandler.bind(this));
		}

		//general_hover_sfx
	}
	mouseOverHandler(e) {
		// window.sm.play({ name: 'general_hover_sfx' });
	}
	mouseDownHandler(e) {
		if (this.name) {
			downObject = this.name;
		}

		if (this.tweener) {
			this.tweener.stop();
		}
		this.tweener = new Tween(this.fg)
			.to({ y: -this.fg.height / 2 + pressHeight }, 50)
			.easing(Easing.Linear.None)
			.start();

		if (this.fg2) {
			this.tweener = new Tween(this.fg)
				.to({ alpha: 0 }, 50)
				.easing(Easing.Linear.None)
				.start();
			this.tweener = new Tween(this.fg2)
				.to({ alpha: 1, y: -this.fg.height / 2 + 10 }, 50)
				.easing(Easing.Linear.None)
				.start();
			if (this.iconActive) {
				// this.tweener = new Tween(this.iconActive.scale).to({ x: 0.8, y: 0.8 }, 50).easing(Easing.Linear.None).start();
			}
			if (this.text && !this.text._text && this.icon.alpha === 0) {
				this.tweener = new Tween(this.iconActive)
					.to({ alpha: 1 }, 50)
					.easing(Easing.Linear.None)
					.start();
			}
		}
	}

	mouseUpHandler(e) {
		if (this.name === downObject || !e) {
			if (this.tweener) {
				this.tweener.stop();
			}
			if (this.fg) {
				this.tweener = new Tween(this.fg)
					.to({ y: -this.fg.height / 2 }, 50)
					.easing(Easing.Linear.None)
					.start();
			}

			if (this.fg2) {
				this.tweener = new Tween(this.fg2)
					.to({ alpha: 0 }, 50)
					.easing(Easing.Linear.None)
					.start();
				if (this.fg) {
					this.tweener = new Tween(this.fg)
						.to({ alpha: 1 }, 50)
						.easing(Easing.Linear.None)
						.start();
				}
				this.iconActive.alpha = 1;
				if (this.iconActive) {
					// this.tweener = new Tween(this.iconActive.scale).to({ x: 1, y: 1 }, 50).easing(Easing.Linear.None).start();
				}
			}
		}
	}

	getSize() {
		return {
			width: this.bg.width,
			height: this.bg.height
		};
	}
}

export default PressButton;
